import { Text } from '@/atoms';

import type { FunctionComponent } from 'react';
import type { TypeTitleProps } from './types';

export const Subtitle: FunctionComponent<TypeTitleProps> = ({
  children,
  className = '',
  as = 'p',
  typographyClass = 'text-headline-h4',
}: TypeTitleProps) => (
  <Text
    as={as}
    className={`md:text-display text-headline ${typographyClass} text-neutrals-0 mb-6 w-full md:w-[590px] ${className}`}
  >
    {children}
  </Text>
);
